import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { FiveStarsPollResultTask } from "../../taskbook.types";
import { PollResultService } from "../../../timeline/timeline-item/poll-result/poll-result.service";
import { PollResultCommentsComponent } from "app/frontend/lib/timeline/timeline-item/poll-result/poll-result-comments/poll-result-comments.component";
import { PollResultValue } from "app/frontend/lib/timeline/timeline-item/poll-result/poll-result.type";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'five-stars-poll-result-task',
    templateUrl: './five-stars-poll-result-task.component.html',
    styleUrls: ['./../task.component.scss', './five-stars-poll-result-task.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FiveStarsPollResultTaskComponent {

    protected average: {
        averageScore: string; 
        people: number
    }
    protected tabIndexToShow: number = 0;
    protected resultsTabLabel: string;
    protected trendsTabLabel: string;
    protected dontWantToAnswerItem: PollResultValue;
    protected participationCount: number;
    protected orderedValues: PollResultValue[]

    @Input() task: FiveStarsPollResultTask;
    @Output() onComment = new EventEmitter();
    @Output() onReported = new EventEmitter()

    constructor(
        private translateService: TranslateService,
        private pollResultService: PollResultService
    ) {
        this.resultsTabLabel = this.translateService.instant('poll_results.results')
        this.trendsTabLabel = this.translateService.instant('poll_results.trends')
    }

    ngOnInit(): void {
        this.average = this.pollResultService.formatFiveStarsPollResult(this.task.results.values)
        this.dontWantToAnswerItem = this.task.results.values.find(x => x.choice === "don-t-want-to-answer")
        this.participationCount = this.pollResultService.getParticipationCount(this.task.results.values)
        this.orderedValues = this.task.results.values.sort((a, b) => b.position - a.position)
    }

    onTabChanged(event){
        this.tabIndexToShow = event.index;
    }

    comment(){
        this.onComment.emit('');
    }

    achive(){
        this.task = undefined
    }

    reportItem(){
        this.onReported.emit();
    }

}